import { render, staticRenderFns } from "./e-copy-text.vue?vue&type=template&id=013a247b&lang=pug"
import script from "./e-copy-text.vue?vue&type=script&lang=js"
export * from "./e-copy-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports